import { ContentWrapper } from '@/General/ContentWrapper'
import { H1 } from '@/General/H1'
import { LoadingSpinner } from '@/General/LoadingSpinner'
import { CheckoutSteps } from '../../../../checkout/CheckoutSteps'

export const RegisterLoadingState = () => {
  return (
    <div>
      <CheckoutSteps current="cart" />
      <ContentWrapper>
        <H1>Register</H1>
        <div className="flex justify-center items-center min-h-[200px]">
          <LoadingSpinner />
        </div>
      </ContentWrapper>
    </div>
  )
}

